module.exports = __webpack_public_path__ + "static/img/logo.ca68b88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newHome/logo.png
// module id = JKIx
// module chunks = 64